import { sync } from 'vuex-pathify';

import { validators } from 'vue-form-generator';

export default {
  data() {
    return {
      // activeModal: 'icebreaker_send',
      modals: {
        // icebreaker_send: {
        //   title: 'Want to send ##NICKNAME## an icebreaker?',

        //   body: "They'll be notified of your request, once they accept you'll be able to start chatting!",
        //   cancel: 'Maybe Later',
        //   ok: 'Alright!',
        //   okAction: () => {
        //     this.sendOrAcceptInvitation();
        //   },
        // },
        // invite_cancel: {
        //   title: "##NICKNAME## hasn't accepted your icebreaker yet",
        //   body: 'Changed your mind or invited them by error?',
        //   cancel: 'Nevermind',
        //   ok: 'Cancel Icebreaker',
        //   okAction: () => {
        //     this.cancelInvitation();
        //   },
        // },
        // invite_accept: {
        //   title: '##NICKNAME## has invited you to chat!',
        //   body: 'Click accept and you can start chatting!',
        //   cancel: 'Maybe Later',
        //   ok: 'Accept',
        //   okAction: () => {
        //     this.sendOrAcceptInvitation();
        //   },
        // },
        // invite_hide: {
        //   title: "Want to hide ##NICKNAME##'s icebreaker?",
        //   body: "We won't notify them",
        //   cancel: 'Not now',
        //   ok: 'Hide',
        //   okAction: () => {
        //     this.hideInvitation();
        //   },
        // },

        // user_unmatch: {
        //   title: 'Want to unmatch with ##NICKNAME##?',
        //   body: 'They will be removed from your matches and your chat list',
        //   cancel: 'Not right now',
        //   ok: 'Unmatch',
        //   okAction: () => {
        //     this.unmatch();
        //   },
        // },

        // user_report: {
        //   title: 'Want to report ##NICKNAME##?',
        //   body: '',
        //   cancel: 'Not right now',
        //   ok: 'Report',
        //   okAction: () => {
        //     this.reportUser();
        //   },
        // },

        // user_disable: {
        //   title: "Want to disable ##NICKNAME##'s account?",
        //   body: "This user's account will be disabled but restorable at any time",
        //   cancel: 'Not right now',
        //   ok: 'Disable',
        //   okAction: () => {
        //     this.disableUser();
        //   },
        // },

        // user_delete: {
        //   title: "Want to delete ##NICKNAME##'s account?",
        //   body: "This user's account will be permanently deleted!",
        //   cancel: 'Not right now',
        //   ok: 'Delete',
        //   okAction: () => {
        //     this.deleteUser();
        //   },
        // },

        // user_deleteData: {
        //   title: "Want to delete ##NICKNAME##'s data?",
        //   body: "All this user's data will be deleted (matches, chats, notifications)",
        //   cancel: 'Not right now',
        //   ok: 'Delete Data',
        //   okAction: () => {
        //     this.deleteUserData();
        //   },
        // },

        // user_ban: {
        //   title: 'Want to ban ##NICKNAME##?',
        //   body: 'This user will be banned and unable to access the website',
        //   cancel: 'Nah',
        //   ok: 'Ban em!',
        //   okAction: () => {
        //     this.banUser();
        //   },
        // },

        // user_debug: {
        //   title: 'Want to debug ##NICKNAME##?',
        //   body: 'It might help with troubleshooting',
        //   cancel: 'No',
        //   ok: 'Yes',
        //   okAction: () => {
        //     this.debugUser();
        //   },
        // },

        // user_ghostMessage: {
        //   title: 'Want to send ##NICKNAME## a ghost message?',
        //   body: 'Better only do it to close friends',
        //   cancel: 'No',
        //   ok: 'Yes',
        //   okAction: () => {
        //     this.broadcastToUser(this.ghostMessageForm.ghost_message);
        //   },
        // },

        // user_reload: {
        //   title: "Want to reload ##NICKNAME##'s browser?",
        //   body: 'It might help bring them on the latest update',
        //   cancel: 'No',
        //   ok: 'Yes',
        //   okAction: () => {
        //     this.broadcastToUser('reload');
        //   },
        // },

        // user_logout: {
        //   title: 'Want to log ##NICKNAME## out?',
        //   body: "I'm sure you have your reasons",
        //   cancel: 'No',
        //   ok: 'Yes',
        //   okAction: () => {
        //     this.broadcastToUser('logout');
        //   },
        // },
      },

      reportForm: {
        report_reason: '',
      },

      banForm: {
        ban_reason: '',
      },

      ghostMessageForm: {
        ghost_message: '',
      },

      reportSchema: {
        fields: [
          {
            type: 'radios',
            label: 'Please tell us the reason',
            model: 'report_reason',
            values: [
              { name: 'This looks like a fake profile', value: 'fake-profile' },
              { name: 'The profile picture does not represent an individual', value: 'bad-picture' },
              { name: 'The profile content is offensive to me', value: 'offensive' },
              { name: 'This person is annoying me', value: 'annoying' },
              { name: "They're pretenting to be me or someone I know", value: 'impersonating' },
            ],
            required: true,
            validator: validators.string,
          },
        ],
      },

      banSchema: {
        fields: [
          {
            type: 'input',
            inputType: 'text',
            label: 'Please type a reason, the user will see this',
            model: 'ban_reason',
            value: 'Your account has been suspended for an undisclosed reason',
            required: true,
            validator: validators.string,
          },
        ],
      },

      ghostMessageSchema: {
        fields: [
          {
            type: 'input',
            inputType: 'text',
            label: 'Please enter text',
            model: 'ghost_message',
            value: '',
            required: true,
            validator: validators.string,
          },
        ],
      },
    };
  },

  computed: {
    ...sync([
      'page', //
      'action/target', //
    ]),

    // titleText() {
    //   return this.modals[this.activeModal].title.replace('##NICKNAME##', this.data.profile.nickname);
    // },
    // bodyText() {
    //   return this.modals[this.activeModal].body;
    // },
    // cancelText() {
    //   return this.modals[this.activeModal].cancel;
    // },
    // okText() {
    //   return this.modals[this.activeModal].ok;
    // },
  },

  methods: {
    userAction(action) {
      console.log(`userAction|modalId:${this.modalId}|action:${action}|data.id:${this.data.id}`);

      if (action === 'chat') {
        this.$router.push({
          name: 'chatroom',
          params: { chatid: this.data.chatroom },
        });
      } else {
        this.target = this.data;
        // this.activeModal = action;
        Bus.$emit('modal:toggle', action);
      }
    },

    // cancelClick() {
    //   this.$root.$emit('bv::hide::modal', this.modalId);
    // },

    // okClick() {
    //   this.$store.set('general/loading', true);
    //   this.modals[this.activeModal].okAction();
    // },

    // okAction(action) {
    //   console.log('ok', action);

    //   axios
    //     .post(`/api/user/actions/${action}`, {
    //       id: this.data.profile.userId,
    //     })
    //     .then((response) => {
    //       // console.log('admin-actions.run', response);

    //       const event = { type: response.data.message, notification: response.data };

    //       Bus.$emit('user:notify', event);
    //     });
    // },

    /* admin actions */

    debugUser() {
      axios
        .post(`/api/admin/user/${this.data.profile.userId}/debug`)
        .then((response) => {
          this.$store.set('general/loading', false);
          this.$root.$emit('bv::hide::modal', this.modalId);
          this.$swal({
            title: 'Debug User',
            html: `<pre class='text-left'>${JSON.stringify(response.data, null, '\t')}</pre>`,
          });
        });
    },

    broadcastToUser(message) {
      axios
        .post(`/api/admin/broadcast/user/${this.data.profile.userId}`, {
          message,
        })
        .then(() => {
          this.$store.set('general/loading', false);
          this.$root.$emit('bv::hide::modal', this.modalId);

          Bus.$emit('user:v-notify', {
            group: 'transient-notifications',
            type: 'success',
            title: 'Success',
            text: `"${message}" delivered!`,
          });
        });
    },

    banUser() {
      if (this.$refs.banForm.validate()) {
        console.log('banning...', this.data.profile.userId);

        axios
          .post(`/api/admin/user/${this.data.profile.userId}/ban`, {
            ban_reason: this.banForm.ban_reason,
          })
          .then(() => {
            this.$store.set('general/loading', false);
            this.$root.$emit('bv::hide::modal', this.modalId);

            this.$swal('Well Done!', "You've crushed them with your ban hammer!", 'success');

            Bus.$emit('refresh');
          });
      } else {
        this.$store.set('general/loading', false);
      }
    },

    disableUser() {
      console.log('disabling user...', this.data.profile.userId);

      axios
        .post(`/api/admin/user/${this.data.profile.userId}/disable`)
        .then(() => {
          this.$store.set('general/loading', false);
          this.$root.$emit('bv::hide::modal', this.modalId);

          this.$swal('User Disabled', 'Operation was succesful', 'success');

          Bus.$emit('refresh');
        });
    },

    // deleteUser() {
    //   console.log('deleting user...', this.data.profile.userId);

    //   axios
    //     .post(`/api/admin/user/${this.data.profile.userId}/delete`)
    //     .then(() => {
    //       this.$store.set('general/loading', false);
    //       this.$root.$emit('bv::hide::modal', this.modalId);

    //       this.$swal('User Deleted', 'Operation was succesful', 'success');

    //       Bus.$emit('refresh');
    //     });
    // },

    deleteUserData() {
      console.log('deleting user data...', this.data.profile.userId);

      axios
        .post(`/api/admin/user/${this.data.profile.userId}/delete-data`)
        .then(() => {
          this.$store.set('general/loading', false);
          this.$root.$emit('bv::hide::modal', this.modalId);

          this.$swal('User Data Deleted', 'Operation was succesful', 'success');

          Bus.$emit('refresh');
        });
    },

    /* user actions */

    reportUser() {
      if (this.$refs.reportForm.validate()) {
        console.log('reporting...', this.data.profile.userId);

        axios
          .post('/api/user/actions/report', {
            id: this.data.profile.userId,
            report_reason: this.reportForm.report_reason,
          })
          .then(() => {
            this.$store.set('general/loading', false);
            this.$root.$emit('bv::hide::modal', this.modalId);

            this.$swal('Thank you', 'Staff will be notified of your report', 'success');
          });
      } else {
        this.$store.set('general/loading', false);
      }
    },

    unmatch() {
      console.log('unmatching...', this.data.profile.userId);

      axios
        .post('/api/user/actions/unmatch', {
          id: this.data.profile.userId,
        })
        .then(() => {
          this.$store.set('general/loading', false);
          this.$root.$emit('bv::hide::modal', this.modalId);

          this.$swal('Success!', 'You have been unmatched', 'success');

          Bus.$emit('refresh');
        });
    },
    hideInvitation() {
      console.log('hiding...', this.data.profile.userId);

      axios
        .post('/api/user/actions/hide-icebreaker', {
          id: this.data.profile.userId,
        })
        .then(() => {
          this.$store.set('general/loading', false);
          this.$root.$emit('bv::hide::modal', this.modalId);

          this.$swal('Success!', 'Their icebreaker has been sent into oblivion!', 'success');

          Bus.$emit('refresh');
        });
    },

    cancelInvitation() {
      // Cancel icebreaker
      axios
        .delete('/api/match/chat', {
          params: {
            id: this.data.profile.userId,
          },
        })
        .then(() => {
          this.$store.set('general/loading', false);
          this.$root.$emit('bv::hide::modal', this.modalId);

          this.$swal('Icebreaker Canceled!', 'You can change your mind anytime', 'success');

          Bus.$emit('refresh');
        });
    },
  },
};
